export const ENGLISH_DATE_LOCALE = 'en-US';

type DateValue = Date | number | string | null | undefined;

const parseDateValue = (value: DateValue): Date | null => {
  if (value === null || value === undefined) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatEnglishDate = (
  value: DateValue,
  options?: Intl.DateTimeFormatOptions,
) => {
  const date = parseDateValue(value);

  return date ? date.toLocaleDateString(ENGLISH_DATE_LOCALE, options) : '';
};

export const formatEnglishDateTime = (
  value: DateValue,
  options?: Intl.DateTimeFormatOptions,
) => {
  const date = parseDateValue(value);

  return date ? date.toLocaleString(ENGLISH_DATE_LOCALE, options) : '';
};
